/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import Paper from 'core/ui/Paper';
import { currency } from 'core/utils/formatters';
import Typography, { fontStyle } from 'core/ui/Typography';
import SFDataTable from 'core/ui/DataTable';
import { ButtonPrimary } from 'core/ui/Button';
import { useTranslation } from 'react-i18next';
import { Edit } from '@material-ui/icons';
import Box from 'core/ui/Box';
import ModalPayments from './ModalPayments';

export default function ResultSales({ results, setModalForm }) {
  const { t } = useTranslation();
  const [modalPaments, setModalPayments] = useState({ open: false, payments: [] });
  const columns = [
    {
      name: 'User',
      selector: 'userName',
      sortable: true,
      cell: (row) => <Typography style={fontStyle.medium}>{row.userName}</Typography>,
    },
    {
      name: 'Total Gyms',
      selector: 'userName',
      sortable: true,
      right: 1,
      cell: (row) => <Typography style={fontStyle.medium}>{row.gyms?.length}</Typography>,
    },
    {
      name: 'Amount',
      selector: 'total',
      sortable: true,
      right: true,
      cell: (row) => (
        <Typography style={fontStyle.medium} className="tw-font-semibold">
          {currency(row.total)}
        </Typography>
      ),
    },
    {
      selector: 'total',
      sortable: false,
      right: true,
      cell: (row) => (
        <div className="tw-flex tw-flex-row tw-items-end tw-justify-end tw-gap-2">
          {row?.payments?.length > 0 && (
            <ButtonPrimary
              onClick={() => setModalPayments({ open: true, payments: row?.payments })}
            >
              {t('button.rangePayments')}
            </ButtonPrimary>
          )}
          <ButtonPrimary onClick={() => setModalForm({ open: true, userId: row?.userId })}>
            {t('button.addGym')}
          </ButtonPrimary>
        </div>
      ),
    },
  ];

  return (
    <Paper style={{ width: '100%' }}>
      <ModalPayments
        open={modalPaments?.open}
        payments={modalPaments?.payments}
        close={() => setModalPayments({})}
      />
      <SFDataTable
        expandableRows
        expandableRowsComponent={<ExpanableComponent setModalForm={setModalForm} />}
        columns={columns}
        data={results}
        pagination
        showExport
      />
    </Paper>
  );
}

const ExpanableComponent = ({ data, setModalForm }) => {
  const gymsColumns = [
    {
      name: 'Channel',
      selector: 'channelId',
      sortable: true,
      cell: (row) => <Typography style={fontStyle.small}>{row.channel.name}</Typography>,
    },

    {
      name: 'Percent',
      selector: 'percent',
      sortable: true,
      right: true,
      cell: (row) => <Typography style={fontStyle.small}>{currency(row.percent)}</Typography>,
    },
    {
      name: 'Total Date Range',
      sortable: false,
      right: true,
      cell: (row) => (
        <Typography style={fontStyle.small}>
          {data?.totalByGyms &&
            data?.totalByGyms[row.channel?.id] &&
            currency(data?.totalByGyms[row.channel?.id])}
        </Typography>
      ),
    },
    {
      name: '',
      sortable: false,
      right: true,
      cell: (row) => (
        <ButtonPrimary
          onClick={() =>
            setModalForm({ open: true, salesUserChannelId: row?.id, userId: row?.userId })
          }
        >
          <Edit />
        </ButtonPrimary>
      ),
    },
  ];

  return (
    <Box m={5}>
      <SFDataTable columns={gymsColumns} data={data?.gyms} />
    </Box>
  );
};
